module.exports = __webpack_public_path__ + "media/images/countryrect/mq-15726f0acfccd8bf8f7d62edf3a8f735.svg";